module.exports = __webpack_public_path__ + "img/features.7cfe29f6.jpg";